'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var index = require('../node_modules/prop-types/index.js');
var Element = require('./Element.js');
var Leaf = require('./Leaf.js');
var index_es$1 = require('../node_modules/slate/dist/index.es.js');
var index_es = require('../node_modules/slate-react/dist/index.es.js');
var styles = require('./styles.js');

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n['default'] = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

function RenderedText(_ref) {
  var {
    value = []
  } = _ref;
  var classes = styles.useMessageStyles();
  var editor = React__namespace.useMemo(() => index_es.withReact(index_es$1.createEditor()), []);
  var renderElement = React__namespace.useCallback(props => /*#__PURE__*/React__namespace.createElement(Element.Element, props), []);
  var renderLeaf = React__namespace.useCallback(props => /*#__PURE__*/React__namespace.createElement(Leaf.Leaf, props), []);
  return /*#__PURE__*/React__namespace.createElement("div", {
    className: classes.message
  }, /*#__PURE__*/React__namespace.createElement(index_es.Slate, {
    editor: editor,
    value: value
  }, /*#__PURE__*/React__namespace.createElement(index_es.Editable, {
    readOnly: true,
    renderElement: renderElement,
    renderLeaf: renderLeaf
  })));
}
RenderedText.propTypes = {
  value: index.arrayOf(index.object)
};

exports.RenderedText = RenderedText;
